import { useGameState } from '../hooks/useGameState';
import { stones } from '../data/stones';
import { acquireStone } from '../domain/economy';
import { StoneIcon } from '../components/StoneIcon';
import type { Screen } from '../App';

interface ShopScreenProps {
  onNavigate: (next: Screen, stoneId?: string) => void;
}

export function ShopScreen({ onNavigate }: ShopScreenProps) {
  const { state, setState, hasStone } = useGameState();
  const refillable = stones.filter((s) => typeof s.energyCost === 'number' && !hasStone(s.id));

  const handleBuy = (stoneId: string) => {
    const stone = stones.find((s) => s.id === stoneId);
    if (!stone || stone.energyCost == null) return;
    if (state.daily.shopRefillUsed) return;
    if (state.daily.energy < stone.energyCost) return;
    if (hasStone(stoneId)) return;
    setState((s) =>
      acquireStone(
        {
          ...s,
          daily: {
            ...s.daily,
            energy: s.daily.energy - stone.energyCost!,
            shopRefillUsed: true,
          },
        },
        stoneId,
      ),
    );
  };

  return (
    <div className="screen shop">
      <h1>ショップ</h1>
      <p className="shop__balance">
        ✦ 神秘エネルギー<strong>{state.daily.energy}</strong>
      </p>
      <p className="shop__hint">
        低ティア石をエネルギーと交換できます。1日1回まで。
      </p>

      <section className="shop__refill">
        <h2 className="section-title">低ティア補充</h2>
        {refillable.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state__icon">✦</div>
            <div className="empty-state__msg">全種コンプリートおめでとう!</div>
          </div>
        ) : (
          <div className="shop__grid">
            {refillable.map((s) => (
              <div key={s.id} className="shop__item">
                <StoneIcon stone={s} stage={0} size={64} />
                <div className="shop__item-name">{s.name}</div>
                <div className="shop__item-cost">✦ {s.energyCost}</div>
                <button
                  className="btn btn--primary"
                  onClick={() => handleBuy(s.id)}
                  disabled={
                    state.daily.shopRefillUsed ||
                    state.daily.energy < (s.energyCost ?? 0) ||
                    hasStone(s.id)
                  }
                  type="button"
                >
                  {state.daily.shopRefillUsed
                    ? '本日の補充済み'
                    : hasStone(s.id)
                      ? '所持済み'
                      : '補充する'}
                </button>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="shop__inventory">
        <h2 className="section-title">コレクション進捗</h2>
        <p style={{ textAlign: 'center', color: 'var(--gold-bright)', fontSize: '1.1rem' }}>
          ✿ {state.inventory.length} / {stones.length} 種 所持 ✿
        </p>
        <button className="btn" onClick={() => onNavigate('collection')}>
          コレクションを見る
        </button>
      </section>
    </div>
  );
}
